import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const GenerateKoliPageRBAC = {
  pageID: 'b0b16d2b6723f7c924666e2301aa8ac0',
  elementID: {
    BtnGenerateKoli: 'b40543a788fd61c9c0de98c1400dcd8e',
    BtnViewDetailKoli: '0bc8bfe219e3dc652daa986739f40acb',
    BtnPrintKoli: 'ffc04bccad996a42d401887d8e52b04e',
  },
} as const

export const useRBACGenerateKoliPage = createUseRBAC(GenerateKoliPageRBAC.elementID)

export type UseRBACGenerateKoliPageType = ReturnType<typeof useRBACGenerateKoliPage>
